module.exports = require('./module');


//////////////////
// WEBPACK FOOTER
// ./~/coffeescript-module/lib/index.js
// module id = 9
// module chunks = 0